export { default } from '@mui/material/Box';
